import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {CustomerCooperationsActions} from '../store';
import {CustomerCooperationsSelectors} from '../store/selectors';

@Injectable()
export class CustomerCooperationsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadCustomerCooperationsDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadCustomerCooperationsDone() {

    return this.store.pipe(
      select(CustomerCooperationsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(CustomerCooperationsActions.ReadCustomerCooperations());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
